var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-btn',{staticClass:"ml-2 mr-5",attrs:{"to":"/about/eol","active":"","min-width":"0","color":"primary"},on:{"click":_vm.onClick}},[_c('v-badge',{attrs:{"content":"NEW","color":"success"}},[_vm._v(" EOL ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }